export default __webpack_public_path__ + "static/media/Bonito23AvantVibes.167fc117.xml";